<template>
  <a v-bind="$attrs" class="app-link" data-jest="app-link" :class="type" target="_blank">
    <slot />
    <span v-if="text" class="app-link__title">{{ text }}</span>
  </a>
</template>
º

<script>
export default {
  name: 'AppLink',

  props: {
    text: {
      type: String,
      default: '',
    },

    variant: {
      type: String,
      default: '',
    },
  },

  computed: {
    type() {
      return this.variant && `app-link--${this.variant}`
    },
  },
}
</script>

<style scoped>
.app-link {
  font-size: 14px;
  color: var(--c-primary);
  line-height: 20px;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  text-decoration: none;
}

.app-link__title {
  margin-left: 5px;
}
</style>
